import React, { createContext, useState, useContext } from "react";
import { ToastContainer } from "react-toastify";
import client from "../../shared/api/client";

import SettingsAccountDetails from "./components/SettingsAccountDetails";
import { toastSuccess, toastError } from "../../shared/toastHelper";

const SettingsAccountDetailsContext = createContext();

export function useSettingsAccountDetailsContext() {
  return useContext(SettingsAccountDetailsContext);
}

const SettingsAccountDetailsProvider = (props) => {
  const { csrfToken, businessTypes, usStates, stripePublishableKey, settingsPath, lastEditedAt, changelogVersions } = props;

  const [team, setTeam] = useState(props.team);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);

  const updateTeam = async (updates) => {
    setSaving(true);
    setErrors([]);

    try {
      const response = await client.patch(`/teams/${team.id}/update_account_details`, {
        team: updates
      });

      const { team: updatedTeam } = response.data;
      setTeam(updatedTeam);
      toastSuccess("Account details saved successfully");
      return { success: true, team: updatedTeam };
    } catch (error) {
      const errorMessages = error.response?.data?.errors || ["Failed to save account details"];
      setErrors(errorMessages);
      toastError(errorMessages.join(", "));
      return { success: false };
    } finally {
      setSaving(false);
    }
  };

  const value = {
    team,
    setTeam,
    saving,
    errors,
    updateTeam,
    csrfToken,
    businessTypes,
    usStates,
    stripePublishableKey,
    settingsPath,
    lastEditedAt,
    changelogVersions,
  };

  return (
    <SettingsAccountDetailsContext.Provider value={value}>
      {props.children}
    </SettingsAccountDetailsContext.Provider>
  );
};

const SettingsAccountDetailsApp = (props) => (
  <SettingsAccountDetailsProvider {...props}>
    <ToastContainer icon={false} />
    <SettingsAccountDetails />
  </SettingsAccountDetailsProvider>
);

export default SettingsAccountDetailsApp;
